import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class BrandLink extends Component {
  render () {
    return (
      <NavLink to={this.props.url} className={classNames('block bg-charcoal text-center text-white text-sm md:text-md lg:text-sm xl:text-md relative group overflow-hidden pt-9/12 w-full h-0')} aria-label={this.props.title}>
        <span className="absolute top-1/2 -translate-y-1/2 left-0 right-0 block z-10 group-hover:scale-300 group-hover:opacity-0 group-focus:scale-300 group-focus:opacity-0 transition duration-150 transform opacity-100">
          {this.props.title}
        </span>
        <img src={this.props.image.src} alt={this.props.image.alt || this.props.title} className="w-full h-full object-cover block opacity-60 group-hover:opacity-100 group-focus:opacity-100 transition-opacity duration-150 ease-in-out absolute top-0 left-0 right-0" />
      </NavLink>
    )
  }
}

BrandLink.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }).isRequired
}

export default BrandLink
